import { ListItem } from "schema-dts";

export type ListItemData = Omit<ListItem, '@type'>;

export default function createListItem(data: ListItemData): ListItem {
    return {
        '@type': 'ListItem',
        ...data
    }
}